import React, { useState, useContext, useEffect } from "react";
import MainContext from "./MainContext";
import { useNavigate } from "react-router-dom";

// import { SESSION_STORAGE_KEY } from "./../../constants";

const MainContextProvider = ({ children }) => {
     const [signatories , setSignatories ] = useState(() =>{
      const savedItems = sessionStorage.getItem('signatories')
      return savedItems ? JSON.parse(savedItems) : [];
     })
     const [signatoriesDocuments , setSignatoriesDocuments ] = useState([])
    const [merchantDetails , setMerchantDetails] =  useState("")
    const [error , setError] = useState("")
  
  return (
    <MainContext.Provider
      value={{
        signatories,
        setSignatories,
        setSignatoriesDocuments,
        signatoriesDocuments,
        setMerchantDetails,
        merchantDetails,
        setError,
        error
      }}
    >
      {children}
    </MainContext.Provider>
  );
};

export default MainContextProvider;
